// frontend/klaes-app/src/components/FilmFavs/hooks/useFilmFavsAPI.js
import { useCallback } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { apiFetch } from '../utils/api';

// Verwende die gleiche BASE wie in api.js
const API_BASE = 'http://klaes.info';

// Hilfsfunktion für authentifizierte Requests
const authFetch = async (url, options = {}, token) => {
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers,
      },
    });
    
    const text = await response.text();
    
    if (!text || text.trim() === '') {
      if (response.ok) {
        console.warn(`[apiFetch] Leere Antwort mit Status ${response.status} bei ${url}`);
        return [];
      }
      const err = new Error(`Leere Antwort (HTTP ${response.status}) von ${url}`);
      err.status = response.status;
      console.error('[apiFetch]', err.message);
      throw err;
    }
    
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error('JSON Parse Error:', text.substring(0, 200));
      throw new Error('Ungültige JSON-Antwort vom Server');
    }
    
    if (!response.ok) {
      throw new Error(data.error || 'Ein Fehler ist aufgetreten');
    }
    
    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

export const useFilmFavsAPI = () => {
  const { token } = useAuth();

  const fetchEntries = useCallback(
    () => apiFetch('/api/film-favs/entries', { token }),
    [token]
  );

  const addEntry = (entryData, initialRating, currentUser) =>
    apiFetch('/api/film-favs/entries', {
      token,
      method: 'POST',
      body: { ...entryData, initialRating, currentUser },
    });

  const updateEntry = (id, updatedData, newRating, currentUser) =>
    apiFetch(`/api/film-favs/entries/${id}`, {
      token,
      method: 'PUT',
      body: { ...updatedData, newRating, currentUser },
    });

  const deleteEntry = (id) =>
    apiFetch(`/api/film-favs/entries/${id}`, {
      token,
      method: 'DELETE',
    });

  const fetchTags = useCallback(
    () => apiFetch('/api/film-favs/tags', { token }),
    [token]
  );

  const createTag = (newTag) =>
    apiFetch('/api/film-favs/tags', {
      token,
      method: 'POST',
      body: newTag,
    });

  const deleteTag = (tagName) =>
    apiFetch(`/api/film-favs/tags/${encodeURIComponent(tagName)}`, {
      token,
      method: 'DELETE',
    });

  return {
    fetchEntries,
    addEntry,
    updateEntry,
    deleteEntry,
    fetchTags,
    createTag,
    deleteTag,
  };
};